<template>
  <div>
    <div class="app-body app-body-tab-bar-aware" ref="appbody">
      <div class="tab-bar px-1">
        <div class="d-flex h-100 ab-bar-contents-width-restrict justify-content-around align-items-end">
          <div
            v-for="item in this.categories"
            :key="item.id"
            :class="['pb-2 tab-item', {'active-tab-item' : isTabActive(item)}]"
            @click.stop.prevent="goToCategory(item)"
          >
            <TabLink :title="item.title" :key="item.id" :isActive="isTabActive(item)"/>
          </div>
        </div>
      </div>
      <div v-for="item in this.categories" :key="item.id">
        <transition name="fade" mode="out-in">
          <keep-alive>
            <More v-if="item.isMain"
              v-show="isAnActiveCategory(item)"
              :id="item.id"
              :isDisplayed="isAnActiveCategory(item)"
              :detailedMode="true"/>
            <News
              v-else-if="item.isYouTube"
              v-show="isAnActiveCategory(item)"
              :catId="item.id"
              :isDisplayed="isAnActiveCategory(item)"/>
            <More
              v-else
              v-show="isAnActiveCategory(item)"
              :id="item.id"
              :isDisplayed="isAnActiveCategory(item)"
            />
          </keep-alive>
        </transition>
      </div>
      <transition name="fade" mode="out-in">
        <keep-alive v-if="isActiveCategoryNotFound()">
          <More
            :id="activeCategory.category.id"
            :isDisplayed="isActiveCategoryNotFound()"/>
        </keep-alive>
      </transition>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import TabLink from './TabLink.vue'
import { spinnakerApi } from '../js/SpinnakerApi.js'
import More from '../components/More.vue'
import News from '../views/News.vue'

export default {
  name: 'app',
  components: {
    TabLink,
    News,
    More
  },
  data: function () {
    return {
      categories: []
    }
  },
  computed: {
    ...mapState({
      activeCategory: (state) => state.navigation.activeCategory
    }),
    mainCategory () {
      const mainCategory = this.categories.find(category => category.isMain)
      // Displaying 2nd category as main is a backward compatibility fallback for missing Spinnaker config
      // see spinnakerApi.getRootCategories() for more details
      return mainCategory || this.categories[1]
    }
  },
  created: async function () {
    this.categories = await spinnakerApi.getRootCategories()

    this.storeUnsubscribe = this.$store.subscribe((mutation, state) => {
      switch (mutation.type) {
        case 'navigation/goToCategory':
          if (state.navigation.activeCategory?.category) {
            this.onCategoryChange()
          } else {
            this.$store.commit('navigation/goToCategory', this.mainCategory)
          }
          break
      }
    })

    let initialCategory = this.activeCategory?.category
    if (!initialCategory) {
      initialCategory = this.mainCategory
      if (this.$route.query.token || this.$route.query.progId) {
        const youTubeCategory = this.categories.find(category => category.isYouTube)
        initialCategory = youTubeCategory || this.mainCategory
      }
    }
    this.$store.commit('navigation/goToCategory', initialCategory)
  },
  beforeDestroy () {
    this.storeUnsubscribe()
  },
  methods: {
    isActiveCategoryNotFound () {
      return this.activeCategory ? !this.categories.find(category => category.id === this.activeCategory?.category?.id) : false
    },
    isAnActiveCategory (category) {
      // Change also similar code in BurgerMenu.isAnActiveCategory
      return this.activeCategory?.category?.id === category.id
    },
    isAnActiveCategoryParent (category) {
      // Change also similar code in BurgerMenu.isAnActiveCategoryParent
      return this.activeCategory?.category?.parentCategoryIds?.includes(category.id)
    },
    isTabActive (category) {
      // Change also similar code in BurgerMenu.isMenuItemActive
      let isActive = this.isAnActiveCategory(category)
      if (!isActive) {
        if (category.isMain) {
          // Special case when 'Home' has to be highlighted when going from promo carousel
          const isOtherAnActiveCategoryParent = this.categories.find(this.isAnActiveCategoryParent)
          isActive = !isOtherAnActiveCategoryParent && this.activeCategory?.isPromo
        } else {
          // If child category is displayed then tab of it's parent is highlighted
          const isOtherActive = this.categories.find(this.isAnActiveCategory)
          isActive = !isOtherActive && this.isAnActiveCategoryParent(category)
        }
      }
      return isActive
    },
    goToCategory (category) {
      console.info(`Tabs: Requesting active category change to ${category?.title} (${category?.id})`)
      this.$store.commit('navigation/goToCategory', category)
    },
    onCategoryChange () {
      this.$store.commit('hideConnectivityNotice')
      window.scrollTo(0, 0)
    }
  }
}
</script>
